import { CellContext } from '@tanstack/react-table';
import { LinkOrFileFieldCell } from '@/components/table/_fieldDefinitions/linkOrFile/LinkOrFileFieldCell.tsx';
import { LinkOrFileCellDto } from '@/components/table/_fieldDefinitions/linkOrFile/LinkOrFileCellDto.ts';

export const linkOrFileFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as LinkOrFileCellDto | null | undefined;
  return <LinkOrFileFieldCell value={value} />;
};
